import { useState, useRef, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import Style from "./css/style.module.css";
import strFunc from '@/lib/lyg/string';

function ViewCGWordArrPopupArea(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    cg_word_pri_val_arr: [],
    voice: "",
    ...props
  };
  const WordAudioRef = useRef<any>(null);
  const [cg_word_arr, set_cg_word_arr] = useState<any>([]);

  useEffect(() => {
    get_cg_word_by_ajax();
  }, [myProps.cg_word_pri_val_arr]);

  const get_cg_word_by_ajax = () => {
    let cg_word_pri_val_arr = [];
    if (myProps.cg_word_pri_val_arr && myProps.cg_word_pri_val_arr.length > 0) {
      for (let i = 0; i < myProps.cg_word_pri_val_arr.length; i++) {
        let row_pri_val = myProps.cg_word_pri_val_arr[i];
        if (!strFunc.is_empty(row_pri_val)) {
          cg_word_pri_val_arr.push(row_pri_val);
        }
      }
    }
    if (cg_word_pri_val_arr.length == 0) {
      return false;
    }
    let tmp_list_opt: any = {
      s_pri_arr: cg_word_pri_val_arr,
      s_mcomp_seq:"",
      order_id: "a_order_num",
      s_addon_word_file: "1",
      // s_addon_word_file_voice: myProps.voice,
      is_paging: "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/coolen/group_word/list',
      tmp_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_cg_word_arr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  const get_cg_word_tags = () => {
    let cg_word_tags = cg_word_arr.map((item: any, idx: number) => {
      return (
        <tr key={idx}>
          <td>{idx + 1}.</td>
          <td>{item.a_word}</td>
          <td>{item.a_mean}</td>
          <td>
            <button className="btn btn-dark"
              onClick={() => {
                let voice_url ="";
                if(item.word_file_info&&item.word_file_info.img_url){
                  voice_url=item.word_file_info.img_url;
                  if(WordAudioRef.current){
                    WordAudioRef.current.src=voice_url;
                    WordAudioRef.current.play();
                  }
                }
              }}
            >mp3</button>
          </td>
        </tr>
      );
    });

    return cg_word_tags;
  };

  return (
    <div>
      <div>
        단어리스트 ({cg_word_arr.length}개)
      </div>
      <div>
        <table>
          <colgroup>
            <col width={"10px"}></col>
            <col width={"200px"}></col>
            <col width={"*"}></col>
            <col width={"50px"}></col>
          </colgroup>
          <tbody>
            {get_cg_word_tags()}
          </tbody>
        </table>
      </div>
      <div style={{display:"none"}}>
        <audio id="audio_player" ref={WordAudioRef}  src="" ></audio>
      </div>
    </div>
  );
};
export default ViewCGWordArrPopupArea;